import './LayoutSpacing.css'

export const LayoutSpacing = () => {
  return (
    <div className="grid-area-layout-spacing">

    </div>
  )
}